<template>
  <div id="app">
    <keep-alive>
      <router-view class="router-container" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="router-container" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

